import { useState, useEffect, useFormContext, Code,  API, Utility,  Messages } from 'helpers/FormImports';
const SendNotification = () => {
  const {message, setMessage, showMenu, setShowMenu, confirm, setConfirm, error, setError, menuPosition, setMenuPosition, contextMenuRef, iframeRef, iframeRef2, formRef } = useFormContext();
  const companyName = Utility.Storage.CompanyName();
  const [appointmentPass, setAppointmentPass] = useState<string>('');
  const [smsData, setSmsData] = useState<string>('');
  const [sendTo, setSendTo] = useState<string>('5878974092');

  const handleSendNotification = async () => {
    try {
      if(appointmentPass.trim() === '') {
        Utility.Message.Error([`Please enter the appointment password`], setMessage);
        return;
      }

      if(appointmentPass !== '123456') {
        Utility.Message.Error([`Invalid appointment password`], setMessage);
        return;
      }

      const databaseId = Utility.Storage.DatabaseId();
      const companyId = Utility.Storage.CompanyId();
      const segmentId = Number(Code.Option.MessageSegment.APPOINTMENT); 
    
      //console.log("Sending Pickup Message with Company ID:", companyId, "Segment ID:", segmentId);

      if(companyId>0 && segmentId>0) {  
        const response = await API.Data.sendNotification(databaseId, companyId, segmentId, setMessage );
        //console.log(response);
        if(response){
          Utility.Message.Info([`Appointment notification sent successfully`],setMessage);
        }
      }
      
    } catch (error) {
      console.error(error);
    }
  };

  // const generateRecall = async () => {
  //   try {
  //     const companyId = Utility.Storage.CompanyId();
      
  //     const segmentId = Number(Code.Option.MessageSegment.APPOINTMENT); 
    
  //     //console.log("Sending Pickup Message with Company ID:", companyId, "Segment ID:", segmentId);

  //     if(companyId>0 && segmentId>0) {  
  //       const response = await API.Data.generateRecall(companyId, setMessage );
  //       //console.log(response);
  //       if(response){
  //         Utility.Message.Info([`Recall generated successfully`],setMessage);
  //       }
  //     }
      
  //   } catch (error) {
  //     console.error(error);
  //   }
  // };

  const handleSendSMS = async () => {
    try {
      if(smsData.trim() === '') {
        Utility.Message.Error([`Please enter the SMS content`], setMessage);
        return;
      }

      if(sendTo.trim() === '') {
        Utility.Message.Error([`Please enter the recipient's phone number`], setMessage);
        return;
      }

      const response = await API.Data.sendVoipSMS(sendTo, smsData, setMessage);
        //console.log(response);
        if(response){
          setSmsData('');
          Utility.Message.Info([`SMS sent successfully`],setMessage);
        }
      
    } catch (error) {
      console.error(error);
    }
  };

  return (
    <div style={{padding : "100px"}}>
      <Messages.Toast Messages={message} Error={error} />
      <div className='pb4'>Company : {companyName}</div>
      <p>Send Today's Appointment Notification by Twillio SMS</p>
      <p>
        <input 
          type="text" 
          value={appointmentPass} 
          className='tinput mb2 mt1' 
          onChange={(e) => setAppointmentPass(e.target.value)} 
          style={{ border: 'solid 1px #ccc' }}  
        />
      </p>
      <p>
        <button 
          type="button" 
          onClick={handleSendNotification} 
          className={`tbutton`} 
          >
          Send
        </button>
      </p>
      <br/><br/><br/>
      <p>
        <input 
          type="text" 
          value={sendTo} 
          className='tinput mb2 mt1' 
          onChange={(e) => setSendTo(e.target.value)} 
          style={{ border: 'solid 1px #ccc' }}  
        />
      </p>
      <p>
        <textarea
          className={''}
          value={smsData}
          onChange={(e) => setSmsData(e.target.value)}
          style={{ border: 'solid 1px #ccc', width: '300px', height: '100px' }} 
        />
      </p>
      <button 
        type="button" 
        onClick={() => handleSendSMS()} 
        className={`tbutton`} 
        >
        Send SMS by VOIP
      </button>
      {/* <br/><br/><br/>
      <button 
        type="button" 
        onClick={generateRecall} 
        className={`tbutton`} 
        >
        Generate Recall
      </button> */}

    </div>
  );
};

export default SendNotification;